import {  useEffect,useState} from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios"; 
import "../../styles/owner/HomeOwner.css"; // Import the CSS file for styling
import BASE_URL from "../../BaseUrl";
import CourseSection from "./CoursesSection";
import StarRating from "../admin/StarRating";

export default function AdminsSection({message, setMessage, showMessage, setShowMessage,reloadAdmins,bestTeachers, setBestTeachers}) {

    const navigate = useNavigate();
    const [newAdmin, setNewAdmin] = useState({
        name: "",
        email: "",
        password: "",
        phone: "",
        capacity: 0,
        usedCapacity: 0,
        students: 0,
        currentStudents: 0,
        assistants: 0,
        currentAssistants: 0,
        generatedCodes: 0,
        usedCodes: 0,
        expire:null,
    });
    const [messageForTeacher, setMessageForTeacher] = useState("");
    const [showMessageForTeacherFrom, setShowMessageForTeacherForm] = useState(false);
    const [showAddAdminForm, setShowAddAdminForm] = useState(false);
    const [showAddToBestTeachers, setShowAddToBestTeachers] = useState(false);
    const [teacherToAddToBest, setTeacherToAddToBest] = useState({
        teacherId:"",
        name:"",
        description:"",
        image:"",
    });


    const category = ["عربي","انجليزي","رياضيات","فيزياء","كيمياء","أحياء","تاريخ","جغرافيا","فلسفة","علم نفس","دين","فرنساوي","الماني","ايطالي","اسباني","جيولوجيا","علوم","دراسات"];
    const yearsArabic = ["الصف الاول الابتدائي","الصف الثاني الابتدائي","الصف الثالث الابتدائي","الصف الرابع الابتدائي","الصف الخامس الابتدائي","الصف السادس الابتدائي","الصف الاول الاعدادي","الصف الثاني الاعدادي","الصف الثالث الاعدادي","الصف الاول الثانوي","الصف الثاني الثانوي","الصف الثالث الثانوي"];
    const termsArabic = ["الفصل الدراسي الاول", "الفصل الدراسي الثاني"];
    const [admins, setAdmins] = useState([]);
    const changeStyle = (id)=>{
            const el = document.getElementById(id);
            el.style.borderColor = "black";
            el.style.color = "black";
    }
    const [OTP, setOTP] = useState("");
    const [showOTPForm, setShowOTPForm] = useState(false);

    const [showAddNewCourseForm, setShowAddNewCourseForm] = useState(false);
    const [adminToAddNewCourse, setAdminToAddNewCourse] = useState("")
    const [newCourse, setNewCourse] = useState({
        courseId:"",
        name:"",
        term:"",
        year:"",
        category:""
    });


    const clearRevenue = () => {
        axios.put(`${BASE_URL}/owner/clear-revenue?adminId=${editAdmin.id}`, {}, { withCredentials: true })
        .then((response) => {
            setEditAdmin({ ...editAdmin, usedCodes: 0 });
        });
        
    }

    const addBestTeacher = () =>{
        if(teacherToAddToBest.description === "" || teacherToAddToBest.teacherId === "" || teacherToAddToBest.name === "" || teacherToAddToBest.image === ""){
            return;
        }
        axios.post(`${BASE_URL}/owner/new-best`, teacherToAddToBest, { withCredentials: true })
        .then((response)=>{
            setBestTeachers([...bestTeachers, teacherToAddToBest]);
            setMessage("تم اضافة المدرس الي قائمة افضل المدرسين");
            setShowMessage(true);
        })
        .catch(
            (err)=>{
                console.log(err);
            }
        )
    
        }

    const sendNewCourse = ()=>{
            if(newCourse.year === ""){
                const el = document.getElementById("year");
                el.style.borderColor = "red";
                el.style.color = "red";
                return;
            }
            if(newCourse.term === ""){
                const el = document.getElementById("term");
                el.style.borderColor = "red";
                el.style.color = "red";
                return;
            }
            if(newCourse.category === ""){
                const el = document.getElementById("category");
                el.style.borderColor = "red";
                el.style.color = "red";
                return;
            }
            if(newCourse.name === ""){
                const el = document.getElementById("course-name");
                el.style.borderColor = "red";
                el.style.color = "red";
                return;
            }
    
            axios.post(`${BASE_URL}/owner/new-course?adminId=${adminToAddNewCourse}`,newCourse,{withCredentials: true})
            .then((response)=>{
                setMessage(response.data);
                setShowMessage(true);
                setShowAddNewCourseForm(false);
                setNewCourse({
                        courseId:"",
                        name:"",
                        term:"",
                        year:"",
                        category:""
                    })
            }).catch((error)=>{
                console.log(error);
            })
        }


    //for edit admin info
    const [showEditAdminForm, setShowEditAdminForm] = useState(false);
    const [editAdmin, setEditAdmin] = useState(null);

    //for update admin plane
    const [updateAdminPlane, setUpdateAdminPlane] = useState(false);

    //for Deleting the admin info
    const [showDeleteAdmin, setShowDeleteAdmin] = useState(false);
    const [idToDelete, setIdToDelete] = useState("");

    // for reloadding the admins and courses
    const [reloadding, setReloadding] = useState(false);

    // for admin details popup
    const [showAdminDetails, setShowAdminDetails] = useState(false);
    const [adminDetails, setAdminDetails] = useState(null);

    // fetch admin to be edited
    const fetchAdminToEdit = (admin) => {
        setEditAdmin(admin);
        setShowEditAdminForm(true);
    }

    // send updated admin info to backend
    const updateAdmin = async (admin) => {
        await axios.put(`${BASE_URL}/owner/update-info`, admin, { withCredentials: true })
        .then((response) => {
            setMessage(response.data);
            setShowMessage(true);
            setShowEditAdminForm(false);

        }).catch((error) => {
            setMessage(error.response.data || "An error occurred while updating the admin.");
            setShowMessage(true);
            setShowEditAdminForm(false);
        })
        if(updateAdminPlane) {
            await axios.put(`${BASE_URL}/owner/update-plane`, admin, { withCredentials: true })
            .then((response) => {
                setMessage(response.data);
                setShowMessage(true);
                setUpdateAdminPlane(false);
            }).catch((error) => {
                setMessage(error.response.data || "An error occurred while updating the admin plane.");
                setShowMessage(true);
                setUpdateAdminPlane(false);
            });
            setUpdateAdminPlane(false);
        }
        setShowEditAdminForm(false);
        setEditAdmin(null);
        setReloadding(!reloadding); // toggle reloadding to refresh the admins list 
    }

    //send message to teacher
    const sendMessageToTeacher = () => {
        axios.post(`${BASE_URL}/owner/send-message`, {adminId:editAdmin.id, message:messageForTeacher}, { withCredentials: true })
            .then((response) => {
                setMessage(response.data);
                setShowMessage(true);
            }).catch((error) => {
                console.log(error);
                setMessage(error.response.data || "An error occurred while sending the message.");
                setShowMessage(true);
            });
    }

    const getTeacherMessages = (adminId) => {
        console.log("in getTeacherMessages");
        axios.get(`${BASE_URL}/owner/admin-message?adminId=${adminId}`, { withCredentials: true })
            .then((response) => {
                console.log(response.data);
                setMessageForTeacher(response.data||"");
            }).catch((error) => {
                console.log(error);
                setMessage(error.response.data || "An error occurred while fetching the messages.");
                setShowMessage(true);
            });
    }


    // delete admin function
    const deleteAdmin = () => {
        axios.delete(`${BASE_URL}/owner/delete-admin?id=${idToDelete}`, { withCredentials: true })
            .then((response) => {
                setReloadding(!reloadding); // toggle reloadding to refresh the admins list
                setMessage(response.data);
                setShowMessage(true);
                setShowDeleteAdmin(false);
                setIdToDelete("");
            }).catch((error) => {
                setMessage("An error occurred while deleting the admin.");
                console.log(error);
                setShowMessage(true);
                setShowDeleteAdmin(false);});
            }
            
            
    useEffect(() => {
        axios.get(BASE_URL+"/owner/admins", { withCredentials: true })
        .then((response) => {
            console.log(response);
            setAdmins(response.data);
        }).catch((error) => {
            navigate("/");
        });
    }, [reloadding,navigate]);

    const addAdmin = () => {
        if (!newAdmin.name || !newAdmin.email ||!newAdmin.password) {
            setMessage("Please fill in all fields.");
            setShowMessage(true);
            return;
        }
        axios.post(BASE_URL+"/owner/new-admin", newAdmin, { withCredentials: true })
        .then((response) => {
            alert(response.data);
            setShowOTPForm(true);
            setNewAdmin({
                    name: "",
                    email: "",
                    courseId: "",
                    password: "",
                    courseID:"",
                    capacity: 0,
                    usedCapacity: 0,
                    students: 0,
                    currentStudents: 0,
                    assistants: 0,
                    currentAssistants: 0,
                    generatedCodes: 0,
                    usedCodes: 0,
                });
            setShowAddAdminForm(false);                
        }).catch((error) => {
                setMessage(error.response.data || "An error occurred while adding the admin.");
                setShowMessage(true);
                setShowAddAdminForm(false);
        });
    };
    const sendOTP = () => {
        axios.post(BASE_URL+"/owner/confirm-otp", { OTP }, { withCredentials: true })
        .then((response) => {
            setMessage(response.data);
            setShowOTPForm(false);
            setOTP("");
            setShowMessage(true);
            setReloadding(!reloadding); // toggle reloadding to refresh the admins list
        }).catch((error) => {
            setMessage(error.response.data || "An error occurred while sending the OTP.");
            setShowMessage(true);
            setShowOTPForm(false);
        });
    }

    return (
        <div className="admins-section-container">
            <h2>المدرسين</h2> <button onClick={() => {setShowAddAdminForm(true)}}>إضافة مدرس</button>
            <table className="admins-table">
            <thead>
                <tr>
                <th>حذف</th> 
                <th>عرض التفاصيل</th>
                <th>تعديل</th>
                <th>إضافة مادة</th>
                <th>البريد الإلكتروني</th>
                <th>الاسم</th>
                </tr>
            </thead>
            <tbody>
            {admins.map((admin, index) => (
                <tr key={index} className="admin-card">
                <td><button onClick={() => {setIdToDelete(admin.id);setShowDeleteAdmin(true)}}>حذف</button></td>
                <td><button onClick={() => {
                    setAdminDetails(admin);
                    setAdminToAddNewCourse(admin.id);
                    setShowAdminDetails(true);
                    
                }}>عرض التفاصيل</button></td>
                <td><button onClick={()=>{fetchAdminToEdit(admin);
                    getTeacherMessages(admin.id);}}>تعديل</button></td>
                <td><button onClick={()=>{
                    setAdminToAddNewCourse(admin.id);
                    setShowAddNewCourseForm(true);
                }}>إضافة مادة</button></td>

                <td>{admin.email}</td>
                <td>{admin.name}</td>
                </tr>
            ))}
            </tbody>
            </table>
            { showAddAdminForm && (
                <div className="add-admin-form" dir="rtl">
                    <h3>إضافة مدرس جديد</h3>
                    <label>الاسم</label>
                    <input
                        type="text"
                        value={newAdmin.name}
                        onChange={(e) => setNewAdmin({ ...newAdmin, name: e.target.value })}/>
                    <label>البريد الإلكتروني</label>
                    <input
                        type="email"
                        value={newAdmin.email}
                        onChange={(e) => setNewAdmin({ ...newAdmin, email: e.target.value })}/>
                    <label>رقم الهاتف</label>
                    <input
                        type="text"
                        value={newAdmin.phone}
                        onChange={(e) => setNewAdmin({ ...newAdmin, phone: e.target.value })}/>
                    <label>كلمة المرور</label>
                    <input
                        type="password"
                        value={newAdmin.password}
                        onChange={(e) => setNewAdmin({ ...newAdmin, password: e.target.value })}/>
                    <label>السعة</label>
                    <input
                        type="number"
                        value={newAdmin.capacity}
                        onChange={(e) => setNewAdmin({ ...newAdmin, capacity: e.target.value })}/>
                    <label>الطلاب</label>
                    <input
                        type="number"
                        value={newAdmin.students}
                        onChange={(e) => setNewAdmin({ ...newAdmin, students: e.target.value })}/>
                    <label>المساعدين</label>
                    <input
                        type="number"
                        value={newAdmin.assistants}
                        onChange={(e) => setNewAdmin({ ...newAdmin, assistants: e.target.value })}/>
                    <button onClick={addAdmin}>إضافة</button>
                    <button onClick={() => setShowAddAdminForm(false)}>إلغاء</button>
                </div>
            )}

            { showOTPForm && (
                <div className="otp-form">
                    <h3>أدخل رمز OTP</h3>
                    <input
                        type="text"
                        value={OTP}
                        onChange={(e) => setOTP(e.target.value)}
                        placeholder="Enter OTP"/>
                    <button onClick={sendOTP} >إرسال</button>
                </div>
                 )}
            { showEditAdminForm && (
                <div className="overlay">
                    <div className="edit-admin-form">
                        <h3>تعديل معلومات المدرس</h3>
                        <label>الاسم</label>
                        <input
                            type="text"
                            value={editAdmin.name}
                            onChange={(e) => setEditAdmin({ ...editAdmin, name: e.target.value })}/>
                        <label>البريد الإلكتروني</label>
                        <input
                            type="text"
                            value={editAdmin.email}
                            onChange={(e) => setEditAdmin({ ...editAdmin, courseId: e.target.value })} readOnly/>
                        
                        <label>رقم الهاتف</label>
                        <input
                            type="text"
                            value={editAdmin.phone}
                            onChange={(e) => setEditAdmin({ ...editAdmin, phone: e.target.value })}/>
                        <label>السعة</label>
                        
                        <input
                            type="number"
                            value={editAdmin.capacity}
                            onChange={(e) => {setEditAdmin({ ...editAdmin, capacity: e.target.value });setUpdateAdminPlane(true)}}/>
                        <label>الطلاب</label>
                        <input
                            type="number"
                            value={editAdmin.students}
                            onChange={(e) => {setEditAdmin({ ...editAdmin, students: e.target.value });setUpdateAdminPlane(true)}}/>
                        <label>المساعدين</label>
                        <input
                            type="number"
                            value={editAdmin.assistants}
                            onChange={(e) => {setEditAdmin({ ...editAdmin, assistants: e.target.value});setUpdateAdminPlane(true)}}/>
                        <label>الكسب</label>
                        <input
                            type="number"
                            value={editAdmin.usedCodes} readOnly/>
                        <label>تاريخ انتهاء الصلاحية</label>
                        <input
                            type="date"
                            value={editAdmin.expire}
                            onChange={(e) => {setEditAdmin({ ...editAdmin, expire: e.target.value});setUpdateAdminPlane(true)}}/>                
                        
                        <div className="edit-admin-buttons">
                            <button className="update-admin-button" onClick={()=>{updateAdmin(editAdmin)}}>تحديث</button>
                            <button onClick={clearRevenue}>مسح الإيرادات</button>
                            <button onClick={()=>{
                                setTeacherToAddToBest({
                                    teacherId:editAdmin.id,
                                    name:editAdmin.name,
                                    image:editAdmin.id+"."+editAdmin.imageExt,
                                })
                                setShowAddToBestTeachers(true);
                            }}>إضافة للأفضل</button>
                            <button onClick={()=>{
                                setShowMessageForTeacherForm(true);
                            }}>ارسال رسالة</button>
                            <button onClick={() => setShowEditAdminForm(false)}>إغلاق</button>
                        </div>
                    </div>
                </div>
            )}

            { showAdminDetails && (
                <div className="overlay">
                <div className="admin-details-form" dir="rtl">
                    <h3>معلومات المدرس</h3>
                    <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}} dir="ltr">
                        <div style={{width:"150px",height:"150px"}}>
                            <img
                            src={
                            `${BASE_URL}/owner/admin-image?adminId=${adminDetails.id}&ext=${adminDetails.imageExt}` 
                            }
                            alt="avatar"
                            className="avatar"
                            />
                            </div>
                            <StarRating rate={adminDetails.rate}/>
                            <div style={{display:"flex",justifyContent:"space-between",width:"100%"}} dir="ltr">
                            <h6>التقييمات {adminDetails.numberOfRates}</h6>
                                <h6>التقييم {adminDetails.rate}</h6>
                            </div>
                    </div>
                    <label>الاسم</label>
                    <input
                        type="text"
                        value={adminDetails.name}
                        readOnly/>
                    <label>البريد الإلكتروني</label>
                    <input
                        type="email"
                        value={adminDetails.email}
                        readOnly/>
                        
                    <label>رقم الهاتف</label>
                    <input
                        type="text"
                        value={adminDetails.phone}
                        readOnly/>
                    <label>التخصص</label>
                    <input
                        type="text"
                        value={adminDetails.field}
                        readOnly/>
                    <label>السعة</label>
                    <input
                        type="number"
                        value={adminDetails.capacity}
                        readOnly/>

                    <label>السعة المستخدمة</label>
                    <input
                        type="number"
                        value={adminDetails.usedCapacity}
                        readOnly/>

                    <label>السعة المتاحة</label>
                    <input
                        type="number"
                        value={adminDetails.capacity-adminDetails.usedCapacity}
                        readOnly/>

                    <label>الطلاب</label>
                    <input
                        type="number"
                        value={adminDetails.students}
                        readOnly/>

                    <label>الطلاب الحاليين</label>
                    <input
                        type="number"
                        value={adminDetails.currentStudent}
                        readOnly/>
                    <label>المساعدين</label>
                    <input
                        type="number"
                        value={adminDetails.assistants}
                        readOnly/>
                    <label>المساعدين الحاليين</label>
                    <input 
                        type="number"
                        value={adminDetails.currentAssistants}
                        readOnly/>
                     <label>تاريخ الانتهاء</label>
                    <input
                        type="date"
                        value={adminDetails.expire}
                        readOnly/>

                        <CourseSection message={message} setMessage={setMessage} showMessage={showMessage} setShowMessage={setShowMessage} adminId={adminToAddNewCourse} />
                    <button onClick={() => setShowAdminDetails(false)}>إغلاق</button>
                </div>
                <div></div>
                </div>
            )}

            { showDeleteAdmin && (
                <div className="overlay">
                    <div className="delete-admin-confirmation">
                        <h3>هل تريد بالفعل حذف هذا المدرس؟</h3>
                        <div className="edit-admin-buttons">
                        <button style={{ backgroundColor: "red", color: "white" }} onClick={() => deleteAdmin()}>نعم</button>
                        <button style={{ backgroundColor: "green", color: "white" }} onClick={() => setShowDeleteAdmin(false)}>لا</button>
                        </div>
                    </div>
                </div>
            )}

            {showAddNewCourseForm&&(
                <div className="overlay">
                <div className='add-new-course-form'>
                    <h2>مادة جديدة</h2>
                    <label>اسم المادة</label>
                    <input id='course-name' type="text" value={newCourse.name} onChange={(e)=>{setNewCourse({...newCourse, name:e.target.value});
                    changeStyle(e.target.id);
                }} />
                    <div className='year-term-selection'>
                    <select id="year" onChange={(e)=>{setNewCourse({...newCourse, year:e.target.value});
                    changeStyle(e.target.id);
                }}>
                        <option value={""}>--- الصف ---</option>
                        {yearsArabic.map((year,index)=>(
                            <option value={yearsArabic[index]} >{year}</option>
                        ))}
                    </select>
                    <select id="term" onChange={(e)=>{setNewCourse({...newCourse, term:e.target.value});
                    changeStyle(e.target.id);
                }}>
                        <option value={""}>---الفصل الدراسي---</option>
                        {termsArabic.map((term,index)=>(
                            <option value={termsArabic[index]}>{term}</option>
                        ))}
                    </select>
                    <select
                        id="category"
                        onChange={(e) => {setNewCourse({...newCourse, category:e.target.value});
                        changeStyle(e.target.id);
                    }}
                    >
                        <option value="">--التصنيف--</option>
                        {category.map((subj, index) => (
                        <option value={category[index]}>
                            {subj}
                        </option>
                        ))}
                    </select>
                    </div>
                    <div className='new-course-form-buttons'>
                        <button onClick={()=>{
                            setNewCourse({
                                            name:"",
                                            courseId:"",
                                            term:"",
                                            year:"",
                                            category:""
                                        });
                                        setShowAddNewCourseForm(false);
                        }}>إلغاء</button>
                        <button onClick={sendNewCourse}>اضافة المادة</button>
                    </div>
                </div>
                </div>
            )}

            {showAddToBestTeachers&&(
                <div className="overlay">
                <div className='add-new-course-form'>
                    <h2>اضافة الي افضل المدرسين</h2>
                    <lable>الوصف</lable>
                    <textarea type="text" value={teacherToAddToBest.description} onChange={(e)=>{setTeacherToAddToBest({...teacherToAddToBest, description:e.target.value})}} />
                    <div className='edit-admin-buttons'>
                        <button className="edit-admin-button" onClick={()=>{
                            addBestTeacher();
                            setShowAddToBestTeachers(false);
                        }}>Add</button>
                        <button onClick={()=>{
                            setTeacherToAddToBest({
                                teacherId:"",
                                name:"",
                                image:'',
                                description:"",});
                            setShowAddToBestTeachers(false);
                        }}>Cancel</button>

                    </div>

                </div>
                </div>
                )}


            {showMessageForTeacherFrom&&(
                <div className="overlay">
                <div className='add-new-course-form'>
                    <h2>ارسال رسالة</h2>
                    <label>الرسالة</label>
                    <textarea type="text" value={messageForTeacher} onChange={(e)=>{setMessageForTeacher(e.target.value)}} />
                    <div className='edit-admin-buttons'>
                        <button className="edit-admin-button" onClick={()=>{
                            sendMessageToTeacher();
                            setShowMessageForTeacherForm(false);
                            setMessageForTeacher("");
                        }}>ارسال</button>
                        <button onClick={()=>{
                            setMessageForTeacher("");
                            setShowMessageForTeacherForm(false);
                        }}>إلغاء</button>
                    </div>
                </div>
                </div>
            )}
        </div>
    );
}